import { createAction } from "redux-actions";
import { GET_FOUNDATIONS } from "../constants";
import { feathersCreateData } from "../services";
//import { isMobile } from 'react-device-detect';

export const getFoundations = createAction(GET_FOUNDATIONS, () => feathersCreateData('core-server',{
    service : "FOUNDATIONS",
    func : "GET_FOUNDATIONS"
})())